<script>
import { nextTick } from 'vue'
import flatpickr from 'flatpickr'
import { Czech } from "flatpickr/dist/l10n/cs.js"
import { default as English } from "flatpickr/dist/l10n/default.js"
import { Polish } from "flatpickr/dist/l10n/pl.js"

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

import apiUsers from '@/api/api-users.js'
import apiCustomers from '@/api/api-customers.js'
import apiSamples from '@/api/api-samples.js'
import apiSettings from '@/api/api-settings'

import MessageBox from './common/MessageBox.vue'
import MessageBoxQuestion from './common/MessageBoxQuestion.vue'

export default {
    name: 'SampleRegistrationComponent',

    components: {
        MessageBox,
        MessageBoxQuestion
    },

    props: {
        userLanguage: {
            type: String,
            default: 'cz'
        },
        languageStrings: {
            type: Object,
            default: null
        },
        userId: {
            type: Number,
            defaults: -1
        },
        role: {
            type: Number,
            default: 0
        }
    },

    emits: ['form-closed'],

    data() {
        return {
            enums: {
                deliveryPlaces: []
            },

            showMessageBox: false,
            messageBoxText: '',
            showMessageBoxQuestion: false,

            sampleSaved: false,
            newSample: false,

            selectedFolder: -1,
            folders: [],
            machines: [],

            errors: {
                sif: false,
                alsNumber: false,
                folder: false,
                machine: false,
                collectionDate: false
            },

            sample: {
                id: -1,
                sif: '',
                alsNumber: '',
                machine: { id: -1, name: '', internalKey: '', folder: { id: -1, name: '' } },
                collectionDate: null,
                receivingDate: null,
                exchangeDate: null,
                exchanged: false,
                supplemented: null,
                machineWorkingHours: null,
                oilWorkingHours: null,
                collectionPlace: '',
                collectionPersonName: '',
                oilTemperature: null,
                environmentTemperature: null,
                description: '',
                locked: false,
                deliveryPlace: { id: -1 }
            }
        }
    },

    computed: {
        sampleNumber() {
            return this.sample.sif
        }
    },

    watch: {
        selectedFolder: async function() {
            let result = await apiCustomers.getMachines(this.selectedFolder)
            if (result.code === 0) {
                this.machines = result.data.slice().sort((a, b) => (a.name + ' (' + a.folder.name + ')').localeCompare((b.name + ' (' + b.folder.name + ')')))
            }
        },

        sampleNumber: async function() {
            this.sample.alsNumber = this.sampleNumber

            if (this.role > 2 && this.sampleNumber.length >= 8) {
                let result = await apiSamples.sif(this.sampleNumber)
                if (result.code === 0 && result.data != null && result.data.length != '') {
                    console.log(result)
                    if (result.data.collectionDate != null) result.data.collectionDate = dayjs(result.data.collectionDate + 'Z').utcOffset(0).format('YYYY-MM-DDTHH:mm:00')
                    if (result.data.receivingDate != null) result.data.receivingDate = dayjs(result.data.receivingDate + 'Z').utcOffset(0).format('YYYY-MM-DDTHH:mm:00')
                    if (result.data.exchangeDate != null) result.data.exchangeDate = dayjs(result.data.exchangeDate + 'Z').utcOffset(0).format('YYYY-MM-DDTHH:mm:00')
                    if (result.data.deliveryPlace == null) result.data.deliveryPlace = { id: -1 }

                    let f = this.searchFolderRoot(this.folders, result.data.machine.folder.id)
                    if (f != null) {
                        this.selectedFolder = f.id
                    }
                    
                    this.sample = result.data
                }
            }
        }
    },

    async mounted() {
        let result = await apiSettings.getDeliveryPlaces()
        if (result.code === 0) {
            this.enums.deliveryPlaces = result.data
        }

        if (this.role === 1 || this.role === 2) {
            let result = await apiUsers.getUser(this.userId)
            if (result.code === 0) {
                if (this.role === 1) {
                    this.selectedFolder = result.data.customer != null ? result.data.customer.id : -1
                }
            }
        }

        result = await apiUsers.getFlatFolders(this.userId)
        if (result.code === 0) {
            let customers = result.data.slice().sort((a, b) => a.name.localeCompare(b.name))
            this.folders = customers
        }
 
        let urlParams = new URLSearchParams(window.location.search);
        const newParams = new URLSearchParams([...urlParams].map(([key, value]) => [key.toLowerCase(), value]));
        if (newParams.has('sample')) {
            let result = await apiSamples.sif(newParams.get('sample'))
            if (result.code === 0 && result.data != null && result.data != '') {
                if (result.data.collectionDate != null) result.data.collectionDate = dayjs(result.data.collectionDate + 'Z').utcOffset(0).format('YYYY-MM-DDTHH:mm:00')
                if (result.data.receivingDate != null) result.data.receivingDate = dayjs(result.data.receivingDate + 'Z').utcOffset(0).format('YYYY-MM-DDTHH:mm:00')
                if (result.data.exchangeDate != null) result.data.exchangeDate = dayjs(result.data.exchangeDate + 'Z').utcOffset(0).format('YYYY-MM-DDTHH:mm:00')
                if (result.data.deliveryPlace == null) result.data.deliveryPlace = { id: -1 }

                let f = this.searchFolderRoot(this.folders, result.data.machine.folder.id)
                if (f != null) {
                    this.selectedFolder = f.id
                }
                
                this.sample = result.data
            }
            else {
                this.sample.sif = newParams.get('sample')
                this.sample.alsNumber = newParams.get('sample')

                this.sample.collectionDate = dayjs().format('YYYY-MM-DDT00:00:00')
                if (this.role > 1) {
                    this.sample.receivingDate = dayjs().format('YYYY-MM-DDT00:00:00')
                }
            }

            history.replaceState(null, null, window.location.origin + window.location.pathname)
        }
        else {
            this.sample.collectionDate = dayjs().format('YYYY-MM-DDT00:00:00')
        }

        if (this.userLanguage == 'pl') {
            flatpickr.localize(Polish)
        }
        else if (this.userLanguage == 'en') {
            English.firstDayOfWeek = 1
            English.time_24hr = true
            flatpickr.localize(English)
        }
        else {
            flatpickr.localize(Czech)
        }

        flatpickr('#collection-date',
        {
            enableTime: true,
            dateFormat: 'Y-m-dTH:i:S',
            altInput: true,
            altFormat: 'j.n.Y H:i',
            disableMobile: true,
            minuteIncrement: 1,
            defaultDate: 'today'
        })

        flatpickr('#receiving-date',
        {
            enableTime: false,
            dateFormat: 'Y-m-dTH:i:S',
            altInput: true,
            altFormat: 'j.n.Y',
            disableMobile: true,
            minuteIncrement: 1
        })

        flatpickr('#exchange-date',
        {
            enableTime: false,
            dateFormat: 'Y-m-dTH:i:S',
            altInput: true,
            altFormat: 'j.n.Y',
            disableMobile: true,
            minuteIncrement: 1
        })

        await nextTick()
        document.getElementById('editForm').focus()
    },
    
    methods: {
        // Helpers
        stopEnterPropagation() {
            // dummy to stop click propagation upwards in hierarchy            
        },
        searchFolderRoot(elements, id) {
            if (elements == null || elements.length === 0) {
                return null
            }

            for (let i = 0; i < elements.length; i++) {
                if (elements[i].id === id) {
                    return elements[i]
                }
                else {
                    let result = this.searchFolderRoot(elements[i].children, id)
                    if (result != null) {
                        return elements[i]
                    }
                }
            }
        },

        handleFormKeyDown(event) {
            if (event.key === 'Escape') {
                this.closeForm()
            }

            if (event.key === 'Enter') {
                this.saveForm()
            }
        },
        closeForm() {
            this.$emit('form-closed')
        },
        async saveFormAndNew() {
            this.newSample = true
            await this.saveForm()
        },
        async saveForm() {
            let error = false
            if (this.sample.sif == null || this.sample.sif.length === 0) {
                this.errors.sif = true
                error = true
            }
            else {
                this.errors.sif = false
            }
            if (this.sample.alsNumber == null || this.sample.alsNumber.length === 0) {
                this.errors.alsNumber = true
                error = true
            }
            else {
                this.errors.alsNumber = false
            }
            if (this.selectedFolder == null || this.selectedFolder <= 0) {
                this.errors.folder = true
                error = true
            }
            else {
                this.errors.folder = false
            }
            if (this.sample.machine == null || this.sample.machine.id == null || this.sample.machine.id <= 0) {
                this.errors.machine = true
                error = true
            }
            else {
                this.errors.machine = false
            }
            if (this.sample.collectionDate == null || this.sample.collectionDate.length === 0) {
                this.errors.collectionDate = true
                error = true
            }
            else {
                this.errors.collectionDate = false
            }
            if (error) {
                return
            }

            // Check existence
            let result = await apiSamples.sif(this.sample.sif)
            if (result.code != 0 || (result.data != null && result.data != '')) {
                if (result.code === 0 && this.role >= 3) { // Servis and Admin can overwrite
                    this.showMessageBoxQuestion = true
                    return
                }

                this.sampleSaved = false
                this.messageBoxText = this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample035 != null ? this.languageStrings.ui.sample035 : 'Chyba registrace'             
                this.showMessageBox = true
                return
            }

            await this.saveData(this.sample, true)
        },
        async saveData(data, newSample) {
            let result = { code: -1, data: null}
            if (newSample) {
                data.id = -1
                result = await apiSamples.postSample(this.getSampleDataToSend(data))
            }
            else {
                result = await apiSamples.putSample(data.id, this.getSampleDataToSend(data))
            }
            if (result.code === 0) {
                this.sampleSaved = true
                this.messageBoxText = this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample034 != null ? this.languageStrings.ui.sample034 : 'Vzorek zaregistrován'
            }
            else {
                this.sampleSaved = false
                this.messageBoxText = this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample035 != null ? this.languageStrings.ui.sample035 : 'Chyba registrace'             
            }
            this.showMessageBox = true
        },
        getSampleDataToSend(sm) {
            let machine = this.machines.find(m => m.id === sm.machine.id)
            let temp = {
                id: sm.id,
                sif: sm.sif,
                alsNumber: sm.alsNumber,
                machine: { id: machine.id, name: machine.name, internalKey: machine.internalKey, folder: machine.folder },
                collectionDate: sm.collectionDate != null && sm.collectionDate.length === 0 ? null : sm.collectionDate,
                receivingDate: sm.receivingDate != null && sm.receivingDate.length === 0 ? null : sm.receivingDate,
                exchangeDate: sm.exchangeDate != null && sm.exchangeDate.length === 0 ? null : sm.exchangeDate,
                exchanged: sm.exchanged,
                supplemented: sm.supplemented != null && sm.supplemented.toString().length > 0 ? sm.supplemented = Number(sm.supplemented.toString().replace(',', '.')) : null,
                machineWorkingHours: sm.machineWorkingHours != null && sm.machineWorkingHours.toString().length > 0 ? sm.machineWorkingHours = Number(sm.machineWorkingHours) : null,
                oilWorkingHours: sm.oilWorkingHours != null && sm.oilWorkingHours.toString().length > 0 ? sm.oilWorkingHours = Number(sm.oilWorkingHours) : null,
                collectionPlace: sm.collectionPlace,
                collectionPersonName: sm.collectionPersonName,
                oilTemperature: sm.oilTemperature != null && sm.oilTemperature.toString().length > 0 ? sm.oilTemperature = Number(sm.oilTemperature.toString().replace(',', '.')) : null,
                environmentTemperature: sm.environmentTemperature != null && sm.environmentTemperature.toString().length > 0 ? sm.environmentTemperature = Number(sm.environmentTemperature.toString().replace(',', '.')) : null,
                description: sm.description,
                locked: false,
                deliveryPlace: sm.deliveryPlace != null && sm.deliveryPlace.id <= 0 ? null : sm.deliveryPlace
            }
            
            return temp
        },
        messageBoxClosed() {
            this.showMessageBox = false
            if (this.sampleSaved) {
                if (this.newSample) {
                    this.newSample = false
                    this.sampleSaved = false

                    const newSIF = !isNaN(this.sample.sif) ? (Number(this.sample.sif) + 1).toString() : ''

                    this.sample = {
                        id: -1,
                        sif: newSIF,
                        alsNumber: newSIF,
                        machine: { id: -1, name: '', internalKey: '', folder: { id: this.sample.machine.folder.id, name: '' } },
                        collectionDate: this.sample.collectionDate,
                        receivingDate: null,
                        exchangeDate: null,
                        exchanged: false,
                        supplemented: null,
                        machineWorkingHours: null,
                        oilWorkingHours: null,
                        collectionPlace: '',
                        collectionPersonName: '',
                        oilTemperature: null,
                        environmentTemperature: null,
                        description: '',
                        locked: false,
                        deliveryPlace: { id: -1 }
                    }
                }
                else
                    this.closeForm()
            }
        },
        async messageBoxQuestionClosed(result) {
            this.showMessageBoxQuestion = false

            if (result !== 0) {
                return
            }

            await this.saveData(this.sample, false)
        }
    }
}
</script>


<template>
    <div class="edit-form">
        <div id="editForm" @keydown="handleFormKeyDown" tabindex="-1">
            <span class="title">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu011 != null ? languageStrings.ui.menu011 : 'Registrace vzorku' }}</span>
            <img src="@/assets/images/x.svg" @click="closeForm()" />

            <div class="edit-form-wrapper">
                <div class="edit-form-content">
                    <span class="first-column">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample001 != null ? languageStrings.ui.sample001 : 'Č. vzorku' }}</span>
                    <span>
                        <input type="text" :class="errors.sif ? 'error' : ''" v-model="sample.sif" autocomplete="off" />
                        <span class="color-red">&nbsp;*</span>
                    </span>

                    <span v-show="role > 2" class="first-column">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample009 != null ? languageStrings.ui.sample009 : 'Č. vzorku ALS' }}</span>
                    <span v-show="role > 2">
                        <input type="text" :class="errors.alsNumber ? 'error' : ''" v-model="sample.alsNumber" autocomplete="off" />
                        <span class="color-red">&nbsp;*</span>
                    </span>

                    <span v-show="role > 1" class="first-column">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample033 != null ? languageStrings.ui.sample033 : 'Zákazník' }}</span>
                    <span v-show="role > 1">
                        <select :class="errors.folder ? 'error' : ''" v-model="selectedFolder">
                            <option v-for="f in folders" :key="f.id" :value="f.id">{{ f.name }}</option>
                        </select>
                        <span class="color-red">&nbsp;*</span>
                    </span>

                    <span class="first-column">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample003 != null ? languageStrings.ui.sample003 : 'Stroj' }}</span>
                    <span>
                        <select :class="errors.machine ? 'error' : ''" v-model="sample.machine.id">
                            <option v-for="m in machines" :key="m.id" :value="m.id">{{ m.name + ' (' + m.folder.name + ')' }}</option>
                        </select>
                        <span class="color-red">&nbsp;*</span>
                    </span>

                    <span class="first-column">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample002 != null ? languageStrings.ui.sample002 : 'Datum odběru' }}</span>
                    <span :class="errors.collectionDate ? 'error' : ''">                    
                        <input type="text" id="collection-date" v-model="sample.collectionDate" autocomplete="off" />
                        <span class="color-red">&nbsp;*</span>
                    </span>

                    <span class="first-column">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample010 != null ? languageStrings.ui.sample010 : 'Místo předání' }}</span>
                    <span>
                        <select v-model="sample.deliveryPlace.id">
                            <option v-for="p in enums.deliveryPlaces" :key="p.id" :value="p.id">{{ p.name }}</option>
                        </select>
                    </span>

                    <span v-show="role > 1" class="first-column">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample007 != null ? languageStrings.ui.sample007 : 'Datum příjmu' }}</span>
                    <span v-show="role > 1" :class="errors.receivingDate ? 'error' : ''">
                        <input type="text" id="receiving-date" v-model="sample.receivingDate" autocomplete="off" />
                    </span>

                    <span class="first-column">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample011 != null ? languageStrings.ui.sample011 : 'Datum výměny' }}</span>
                    <span>
                        <input type="text" id="exchange-date" v-model="sample.exchangeDate" autocomplete="off" />
                    </span>

                    <span class="first-column">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample012 != null ? languageStrings.ui.sample012 : 'Vyměněno' }}</span>
                    <span>
                        <input type="checkbox" v-model="sample.exchanged" />
                    </span>

                    <span class="first-column">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample013 != null ? languageStrings.ui.sample013 + ' [l]' : 'Doplněno [l]' }}</span>
                    <span>
                        <input type="text" v-model="sample.supplemented" autocomplete="off" />
                    </span>

                    <span class="first-column">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample004 != null ? languageStrings.ui.sample004 + ' [h]' : 'Provozní hodiny stroje [h]' }}</span>
                    <span>
                        <input type="text" v-model="sample.machineWorkingHours" autocomplete="off" />
                    </span>

                    <span class="first-column">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample014 != null ? languageStrings.ui.sample014 + ' [h]' : 'Provozní hodiny oleje [h]' }}</span>
                    <span>
                        <input type="text" v-model="sample.oilWorkingHours" autocomplete="off" />
                    </span>

                    <span class="first-column">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample015 != null ? languageStrings.ui.sample015 : 'Odběrné místo' }}</span>
                    <span>
                        <input type="text" v-model="sample.collectionPlace" autocomplete="off" />
                    </span>

                    <span class="first-column">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample016 != null ? languageStrings.ui.sample016 : 'Odběr provedl' }}</span>
                    <span>
                        <input type="text" v-model="sample.collectionPersonName" autocomplete="off" />
                    </span>

                    <span class="first-column">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample017 != null ? languageStrings.ui.sample017 + ' [°C]' : 'Teplota oleje [°C]' }}</span>
                    <span>
                        <input type="text" v-model="sample.oilTemperature" autocomplete="off" />
                    </span>

                    <span class="first-column">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample018 != null ? languageStrings.ui.sample018 + ' [°C]' : 'Teplota prostředí [°C]' }}</span>
                    <span>
                        <input type="text" v-model="sample.environmentTemperature" autocomplete="off" />
                    </span>

                    <span class="first-column">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample006 != null ? languageStrings.ui.sample006 : 'Popis' }}</span>
                    <span>
                        <textarea v-model="sample.description" @keydown.stop="stopEnterPropagation"></textarea>
                    </span>
                </div>

                <div class="edit-form-buttons">
                    <button class="button-small" @click="saveForm">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.form001 != null ? languageStrings.ui.form001 : 'Uložit' }}</button>
                    <button class="button-small" @click="saveFormAndNew">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.form008 != null ? languageStrings.ui.form008 : 'Uložit a nový' }}</button>
                    <button class="button-small" @click="closeForm">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.form002 != null ? languageStrings.ui.form002 : 'Zrušit' }}</button>
                </div>
            </div>
        </div>
    </div>

    <MessageBoxQuestion v-if="showMessageBoxQuestion" @form-closed="messageBoxQuestionClosed" :type="1"
        :text="languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample036 != null ? languageStrings.ui.sample036 : 'Vzorek již existuje. Data budou přepsána.'" 
        :yesButtonText="languageStrings != null && languageStrings.ui != null && languageStrings.ui.form003 != null ? languageStrings.ui.form003 : 'Ano'"
        :noButtonText="languageStrings != null && languageStrings.ui != null && languageStrings.ui.form004 != null ? languageStrings.ui.form004 : 'Ne'"
    />

    <MessageBox v-if="showMessageBox" :text="messageBoxText" @form-closed="messageBoxClosed" />
</template>